import { render, staticRenderFns } from "./NewAppointmentMobile.vue?vue&type=template&id=2da83f22&scoped=true&"
import script from "./NewAppointmentMobile.vue?vue&type=script&lang=js&"
export * from "./NewAppointmentMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewAppointmentMobile.vue?vue&type=style&index=0&id=2da83f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da83f22",
  null
  
)

export default component.exports